import 'torque-ui/styles/globals.css';
import '../styles/global.css';

import { useEffect } from 'react';
import { hotjar } from 'react-hotjar';

import { CameraProvider } from "@berbix/react-advanced-sdk";
import { StoreProvider } from '@/store';

import type { AppProps } from 'next/app';
import { fontSans, fontTitle, fontBody } from 'torque-ui/styles/fonts';

const useHotjar = process.env.NEXT_PUBLIC_ACT_ENV === "production";

function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    if (typeof window !== "undefined" && useHotjar) {
      hotjar.initialize(3126887, 6);
    }
  }, []);

  return (
    <>
    <style jsx global>{`
      :root {
        --font-sans: ${fontSans.fontFamily};
        --font-title: ${fontTitle.style.fontFamily};
        --font-body: ${fontBody.style.fontFamily};
      }
    `}</style>
      <StoreProvider {...pageProps}>
        <CameraProvider>
          <Component {...pageProps} />
        </CameraProvider>
      </StoreProvider>
    </>
  );
  }

export default MyApp;